<template>
  <div
    class="content-light"
    v-bind:class="hidediv ? 'dis' : ''"
    v-on:lock="noScroll()"
    v-on:unlock="scroll()"
    @keydown.tab="handleContestTabNavigation($event)"
    id="election-modalx"
  >
    <md-progress-bar md-mode="query" v-show="!loaded"></md-progress-bar>
    <!-- Alert per pari opportunità -->
    <div
      class="title-alert"
      v-if="
        electionType &&
          electionType.indexOf('EQUAL_OPPORTUNITIES') !== -1 &&
          listOrCandidates === 'CANDIDATES'
      "
    >
      <b v-if="electionType == 'AIDED_EQUAL_OPPORTUNITIES'">
        {{ $t("election.aided-equal-opportunities-alert") }}</b
      >
      <span v-if="electionType == 'AIDED_THREE_EQUAL_OPPORTUNITIES'">
        {{ $t("election.aided-three-equal-opportunities-alert") }}</span
      >
    </div>
    <div v-if="election && contestList">
      <div class="md-layout content-election-w">
        <div v-if="contestLevels === 0" id="one-contest-level">
          <div
            class="fixtab"
            :id="contest.Id"
            v-for="contest in unorderedContests"
            :key="contest.Id"
          >
            <div class="md-subtitle">
              {{
                listOrCandidates == "CANDIDATES"
                  ? $t("election.candidates-list") + ". "
                  : $t("election.affiliations-list") + ". "
              }}
              <span aria-hidden="true">
                {{ $t("election.scroll-page-indication") }}.</span
              >
              <span
                v-if="listOrCandidates === 'CANDIDATES'"
                class="screenreader"
                >{{ $t("election.screen-reader.candidates.indication") }}:
                {{ election.Election[0].MaxVotes }}</span
              >
              <span
                v-if="listOrCandidates === 'AFFILIATIONS'"
                class="screenreader"
                >{{ $t("election.screen-reader.affiliations.indication") }}:
                {{ election.Election[0].MaxVotes }}</span
              >
              <br />
            </div>
            <!-- Info per votare -->
            <infoBox
              v-if="utils.getViewInfoBox()"
              @keydown.tab="utils.handleContestTabNavigation($event)"
              :showNullVote="election.Election[0].NullChoiceIdentifier"
              :listOrCandidates="listOrCandidates"
              :hasPreferences="listWithPreference"
            ></infoBox>
            <contest
              :contestId="contest.Id"
              class="content-light-w"
              @candidateInContestSelected="selectCandidateInContest"
              @affiliationInContestSelected="selectAffiliationInContest"
              @affiliationConfirmed="affiliationConfirmed"
              @contestRetrieved="
                blankOrNullActive = true;
                loaded = true;
                $emit('progressbar-loaded');
              "
              @num-cand-or-aff="totalCandidatesOrAffiliations"
              @hasContest="listWithPreference = true"
              :loadContest="contestNames[contest.Id]"
              :visibleContest="true"
              :disabled="tooMany"
              :electionType="electionType"
              :listOrCandidates="listOrCandidates"
              v-if="!contest.Category"
              :sexVoted="sexVoted"
              :electionName="
                election.Election[0].ElectionIdentifier.ElectionName
              "
              :electionId="electionId"
              :loadDeferredContest="loadDeferredContest"
              ref="contest"
            >
            </contest>
          </div>
        </div>
        <div v-else>
          <span class="screenreader">
            {{
              listOrCandidates == "CANDIDATES"
                ? $t("election.screen-reader.candidates.tab-partition") + ". "
                : $t("election.screen-reader.affiliations.tab-partition") + ". "
            }}
            {{ $t("election.screen-reader.tabs-navigation") }}.</span
          >
          <md-tabs
            class="light-w "
            v-if="election && contestList"
            @md-changed="changeTab($event, true)"
            md-alignment="centered"
            :id="OUTER_TABS_CONTAINER"
            :key="OUTER_TABS_CONTAINER"
          >
            <md-tab
              :aria-label="$t('election.how-to-vote-tab.title')"
              class="fixtab"
              :id="CONTEST_INTRO_PAGE"
              :md-label="$t('election.how-to-vote-tab.title')"
              :md-disabled="changed"
              v-if="contestLevels > 0"
              ><div v-if="listOrCandidates">
                <p>
                  {{ $t("election.how-to-vote-tab.intro") }}
                  {{
                    listOrCandidates == "CANDIDATES"
                      ? $t("election.candidates-label")
                      : $t("election.affiliations-label")
                  }}. {{ $t("election.how-to-vote-tab.select-tab") }}
                  {{
                    listOrCandidates == "CANDIDATES"
                      ? $t("election.the-m") + $t("election.candidates-label")
                      : $t("election.the-f") +
                        $t("election.affiliations-label")
                  }}{{ $t("election.how-to-vote-tab.select-tab2") }}.
                </p>
                <p v-if="listOrCandidates == 'CANDIDATES'">
                  <strong
                    >{{
                      $t(
                        "election.how-to-vote-tab.candidates.alphabetical-order"
                      )
                    }}:</strong
                  >
                  {{
                    $t(
                      "election.how-to-vote-tab.candidates.alphabetical-select-and-vote"
                    )
                  }}.
                </p>
                <p v-if="listOrCandidates == 'AFFILIATIONS'">
                  <strong
                    >{{
                      $t(
                        "election.how-to-vote-tab.affiliations.alphabetical-order"
                      )
                    }}:</strong
                  >
                  {{
                    $t(
                      "election.how-to-vote-tab.affiliations.alphabetical-select-and-vote"
                    )
                  }}.
                </p>

                <p v-if="listOrCandidates == 'CANDIDATES'">
                  <strong
                    >{{
                      $t("election.how-to-vote-tab.candidates.different-order")
                    }}:</strong
                  >
                  {{
                    $t(
                      "election.how-to-vote-tab.candidates.different-select-and-vote"
                    )
                  }}.
                </p>
                <p v-if="listOrCandidates == 'AFFILIATIONS'">
                  <strong
                    >{{
                      $t(
                        "election.how-to-vote-tab.affiliations.different-order"
                      )
                    }}:</strong
                  >
                  {{
                    $t(
                      "election.how-to-vote-tab.affiliations.different-select-and-vote"
                    )
                  }}.
                </p>

                <p>
                  <span
                    v-if="election.Election[0].NullChoiceIdentifier == null"
                    >{{ $t("election.how-to-vote-tab.blank-vote") }}</span
                  ><span v-if="election.Election[0].NullChoiceIdentifier">{{
                    $t("election.how-to-vote-tab.more-blank-vote")
                  }}</span>
                  <span v-if="election.Election[0].NullChoiceIdentifier"
                    >{{ $t("election.how-to-vote-tab.null-vote") }} </span
                  >{{ $t("election.how-to-vote-tab.with") }}
                  <span v-if="election.Election[0].NullChoiceIdentifier == null"
                    >{{ $t("election.how-to-vote-tab.one-vote-button") }}.</span
                  ><span v-if="election.Election[0].NullChoiceIdentifier"
                    >{{
                      $t("election.how-to-vote-tab.more-vote-buttons")
                    }}.</span
                  >
                </p>
              </div>
            </md-tab>
            <md-tab
              :id="contest.Id"
              class="fixtab"
              :md-label="
                orderedContests.length > 1 || unorderedContests.length > 1
                  ? contest.ContestName.includes('Pagina')
                    ? contest.ContestName.replace(
                        'Pagina',
                        $t('election.how-to-vote-tab.page')
                      )
                    : contest.ContestName
                  : ''
              "
              :aria-label="
                orderedContests.length > 1 || unorderedContests.length > 1
                  ? contest.ContestName.includes('Pagina')
                    ? contest.ContestName.replace(
                        'Pagina',
                        $t('election.how-to-vote-tab.page')
                      )
                    : contest.ContestName
                  : ''
              "
              v-for="contest in unorderedContests"
              :key="contest.Id"
              aria-hidden="true"
            >
              <div class="md-subtitle">
                {{
                  listOrCandidates == "CANDIDATES"
                    ? $t("election.candidates-list") +
                      " " +
                      labelContesto(
                        contest.ContestName.includes("Pagina")
                          ? contest.ContestName.replace(
                              "Pagina",
                              $t("election.how-to-vote-tab.page")
                            )
                          : contest.ContestName,
                        $t("election-event.screen-reader.from-date"),
                        $t("election-event.screen-reader.to-date")
                      )
                    : $t("election.affiliations-list") +
                      " " +
                      labelContesto(
                        contest.ContestName.includes("Pagina")
                          ? contest.ContestName.replace(
                              "Pagina",
                              $t("election.how-to-vote-tab.page")
                            )
                          : contest.ContestName,
                        $t("election-event.screen-reader.from-date"),
                        $t("election-event.screen-reader.to-date")
                      )
                }}
                <span aria-hidden="true"
                  >{{ $t("election.scroll-page-indication") }}.</span
                >
                <span
                  v-if="listOrCandidates === 'CANDIDATES'"
                  class="screenreader"
                  >{{ $t("election.screen-reader.candidates.indication") }}:
                  {{ election.Election[0].MaxVotes }}</span
                >
                <span
                  v-if="listOrCandidates === 'AFFILIATIONS'"
                  class="screenreader"
                >
                  {{ $t("election.screen-reader.affiliations.indication") }}:
                  {{ election.Election[0].MaxVotes }}</span
                >
                <br />
              </div>
              <!-- Info per votare -->
              <infoBox
                v-if="utils.getViewInfoBox()"
                @keydown.tab="
                  utils.handleTabNavigation(
                    $event,
                    null,
                    null,
                    '#infobox',
                    null
                  )
                "
                :showNullVote="election.Election[0].NullChoiceIdentifier"
                :listOrCandidates="listOrCandidates"
                :hasPreferences="listWithPreference"
              ></infoBox>
              <contest
                :contestId="contest.Id"
                class="content-light-w"
                @candidateInContestSelected="selectCandidateInContest"
                @affiliationInContestSelected="selectAffiliationInContest"
                @affiliationConfirmed="affiliationConfirmed"
                @contestRetrieved="
                  blankOrNullActive = true;
                  loaded = true;
                  $emit('progressbar-loaded');
                "
                @num-cand-or-aff="totalCandidatesOrAffiliations"
                :loadContest="contestNames[contest.Id]"
                :visibleContest="visibleContests[contest.Id]"
                :disabled="tooMany"
                :electionType="electionType"
                :listOrCandidates="listOrCandidates"
                v-if="!contest.Category"
                :sexVoted="sexVoted"
                :electionName="
                  election.Election[0].ElectionIdentifier.ElectionName
                "
                :electionId="electionId"
                :loadDeferredContest="loadDeferredContest"
                ref="contest"
              >
                // per prendere la proprietà per caricarre i contest all'inizio
                o meno:
                //:deferrdContestLoading="election.la.proprietà.deferred.contest"
              </contest>
            </md-tab>

            <md-tab
              class="fixtab single-tab-w"
              :id="contestGroup.elements[0].Category"
              :md-label="contestGroup.elements[0].Category"
              :aria-label="contestGroup.elements[0].Category"
              v-for="contestGroup in orderedContests"
              :key="contestGroup.elements[0].Category"
            >
            </md-tab>
          </md-tabs>
        </div>

        <md-tabs
          md-alignment="centered"
          @md-changed="changeTab($event, false)"
          :id="INNER_TABS_CONTAINER + contestGroup.elements[0].Category"
          :key="INNER_TABS_CONTAINER + contestGroup.elements[0].Category"
          v-for="contestGroup in orderedContests"
          v-show="categorySelected[contestGroup.elements[0].Category]"
          :md-active-tab="
            CATEGORY_INTRO_PAGE + contestGroup.elements[0].Category
          "
        >
          <md-tab
            :aria-label="$t('election.inner-tab.title')"
            class="fixtab"
            :id="CATEGORY_INTRO_PAGE + contestGroup.elements[0].Category"
            :md-label="$t('election.inner-tab.title')"
            v-if="contestLevels > 0"
            :md-disabled="changedSecondLevel"
            ><div
              v-if="listOrCandidates"
              :key="
                CATEGORY_INTRO_PAGE +
                  contestGroup.elements[0].Category +
                  (categorySelected[contestGroup.elements[0].Category]
                    ? 'active'
                    : '')
              "
            >
              <p>{{ $t("election.inner-tab.intro") }}.</p>
            </div>
          </md-tab>

          <md-tab
            aria-hidden="true"
            :aria-controls="contest.ContestName"
            :aria-label="contest.ContestName"
            class="fixtab"
            :id="contest.Id"
            :md-label="contest.ContestName"
            v-for="contest in contestGroup.elements"
            :key="contest.Id"
          >
            <div class="md-subtitle">
              {{
                listOrCandidates == "CANDIDATES"
                  ? $t("election.candidates-list") +
                    " " +
                    labelContesto(
                      contest.ContestName,
                      $t("election-event.screen-reader.from-date"),
                      $t("election-event.screen-reader.to-date")
                    )
                  : $t("election.affiliations-list") +
                    " " +
                    labelContesto(
                      contest.ContestName,
                      $t("election-event.screen-reader.from-date"),
                      $t("election-event.screen-reader.to-date")
                    )
              }}
              <span aria-hidden="true">
                {{ $t("election.scroll-page-indication") }}.</span
              >
              <span
                v-if="listOrCandidates === 'CANDIDATES'"
                class="screenreader"
                >{{ $t("election.screen-reader.candidates.indication") }}:
                {{ election.Election[0].MaxVotes }}</span
              >
              <span
                v-if="listOrCandidates === 'AFFILIATIONS'"
                class="screenreader"
                >{{ $t("election.screen-reader.affiliations.indication") }}:
                {{ election.Election[0].MaxVotes }}</span
              >
              <br />
              <infoBox
                v-if="utils.getViewInfoBox()"
                @keydown.tab="utils.handleContestTabNavigation($event)"
                :showNullVote="election.Election[0].NullChoiceIdentifier"
                :listOrCandidates="listOrCandidates"
                :hasPreferences="listWithPreference"
              ></infoBox>
            </div>
            <contest
              :id="contest.ContestName"
              class="content-light-w"
              :aria-labelledby="contest.Id"
              :contestId="contest.Id"
              @candidateInContestSelected="selectCandidateInContest"
              @affiliationInContestSelected="selectAffiliationInContest"
              @affiliationConfirmed="affiliationConfirmed"
              @contestRetrieved="
                blankOrNullActive = true;
                loaded = true;
                $emit('progressbar-loaded');
              "
              @num-cand-or-aff="totalCandidatesOrAffiliations"
              :loadContest="contestNames[contest.Id]"
              :visibleContest="visibleContests[contest.Id]"
              :disabled="tooMany"
              :electionType="electionType"
              :listOrCandidates="listOrCandidates"
              :sexVoted="sexVoted"
              :electionName="
                election.Election[0].ElectionIdentifier.ElectionName
              "
              :electionId="electionId"
              :loadDeferredContest="loadDeferredContest"
            >
              // per prendere la proprietà per caricarre i contest all'inizio o
              meno:
              //:deferrdContestLoading="election.la.proprietà.deferred.contest"
            </contest>
          </md-tab>
        </md-tabs>
      </div>
      <div class="toolbar toolbar-w">
        <md-card class="md-layout-item md-size-100 toolbar-w">
          <div class="md-layout">
            <div
              class="preferenze-label md-layout-item mg md-size-30"
              style="position:relative;left:0;"
              v-if="listOrCandidates == 'CANDIDATES'"
            >
              <!--aria-live="assertive"-->
              <span class="screenreader"
                >{{ $t("election.screen-reader.preferences-summary") }}:</span
              >
              {{ $t("election.preferences.candidates.max-number") }}:
              {{ election.Election[0].MaxVotes }}<br />
              <span class="screenreader"> e </span>
              {{ $t("election.preferences.candidates.selected-number") }}:
              {{ voted.length }}
            </div>
            <div
              class="preferenze-label md-layout-item mg md-size-30"
              style="position:relative;left:0;"
              v-if="listOrCandidates == 'AFFILIATIONS'"
            >
              <!--:aria-live="hasPreferences && !readAriaLive ? 'off' : 'assertive'"-->
              <span class="screenreader"
                >{{ $t("election.screen-reader.preferences-summary") }}:
              </span>
              {{ $t("election.preferences.affiliations.max-number") }}:
              {{ election.Election[0].MaxVotes }}<br />
              <span class="screenreader"> e </span>
              {{ $t("election.preferences.affiliations.selected-number") }}:
              {{ listVoted.length }}
            </div>
            <div
              id="electionVoteButtons"
              class="md-layout-item mg action-button md-size-35"
            >
              <md-button
                :id="BLANK_VOTE"
                @click="
                  voteBlank = true;
                  openFinalConfirm = true;
                  lastClick();
                "
                class="md-raised md-accent"
                :disabled="
                  !blankOrNullActive ||
                    atLeastOne ||
                    openFinalConfirm ||
                    voteSent
                "
                :aria-disabled="
                  !blankOrNullActive ||
                    atLeastOne ||
                    openFinalConfirm ||
                    voteSent
                "
              >
                <md-tooltip
                  v-bind:style="isMobile ? 'display: none;' : ''"
                  class="tooltip"
                  >{{ $t("election-list.blank-button") }}
                </md-tooltip>
                {{ $t("election-list.blank-button") }}
              </md-button>

              <md-button
                :id="NULL_VOTE"
                @click="
                  voteNull = true;
                  openFinalConfirm = true;
                  lastClick();
                "
                class="md-raised md-accent"
                :disabled="
                  !blankOrNullActive ||
                    atLeastOne ||
                    openFinalConfirm ||
                    voteSent
                "
                :aria-disabled="
                  !blankOrNullActive ||
                    atLeastOne ||
                    openFinalConfirm ||
                    voteSent
                "
                v-if="election.Election[0].NullChoiceIdentifier"
              >
                <md-tooltip
                  v-bind:style="isMobile ? 'display: none;' : ''"
                  class="tooltip"
                  >{{ $t("election-list.null-button") }}
                </md-tooltip>
                {{
                  $i18n.locale == "it"
                    ? election.Election[0].NullChoiceIdentifier.Value
                    : $t("election-list.null-button")
                }}
              </md-button>

              <md-button
                :id="VOTE"
                @click="lastClickVote"
                class="md-raised md-primary md-mini"
                style="margin-right:0px;"
                :disabled="!ready || openFinalConfirm || voteSent"
                :aria-disabled="!ready || openFinalConfirm || voteSent"
                ><md-tooltip
                  v-bind:style="isMobile ? 'display: none;' : ''"
                  class="tooltip"
                  >{{ $t("election.vote-button-tooltip") }}</md-tooltip
                >
                {{ $t("election.vote-button") }}
              </md-button>
            </div>
          </div>
        </md-card>
      </div>

      <no-all-preference-dialog
        @opened="noScroll()"
        @closed="scroll()"
        :confirmVoteDialog="confirmVoteDialog"
        @openFinalConfirm="
          openFinalConfirm = true;
          confirmVoteDialog = false;
        "
        @cancel="confirmVoteDialog = false"
      ></no-all-preference-dialog>

      <!-- <confirm-null-vote-dialog
        @opened="noScroll()"
        @closed="scroll()"
        :confirmBlank="confirmBlank"
        @openFinalConfirm="
          openFinalConfirm = true;
          confirmBlank = false;
          voteBlank = true;
        "
        @cancel="
          confirmBlank = false;
          voteBlank = false;
        "
      ></confirm-null-vote-dialog>-->
      <!-- <confirm-real-null-vote-dialog
        @opened="noScroll()"
        @closed="scroll()"
        :confirmNull="confirmNull"
        @openFinalConfirm="
          openFinalConfirm = true;
          confirmNull = false;
          voteNull = true;
        "
        @cancel="
          confirmNull = false;
          voteNull = false;
        "
      ></confirm-real-null-vote-dialog>-->
      <final-confirm-vote
        :openFinalConfirm="openFinalConfirm"
        :listOrCandidates="listOrCandidates"
        :voted="voted"
        :listVoted="listVoted"
        :voteBlank="voteBlank"
        :voteNull="voteNull"
        :hasPreferences="hasPreferences"
        @finalConfirmationVote="
          $emit('scheda-urna');
          finalConfirmationVote();
        "
        @finalConfirmationCancel="
          finalConfirmationCancel();
          finalConfirmCancel = true;
        "
        @opened="
          noScroll();
          !isMobile ? utils.modalOpened('#finalConfirmationVote') : '';
        "
        @closed="
          !isMobile ? utils.removeModalHandler() : '';
          scroll();
        "
      >
      </final-confirm-vote>
    </div>
  </div>
</template>

<script>
import ElectionMixin from "./ElectionLogicMixin";
import Contest from "./Contest";
import NoAllPreferenceDialog from "./NoAllPreferenceDialog";
//import ConfirmNullVoteDialog from "./ConfirmNullVoteDialog";
//import ConfirmRealNullVoteDialog from "./ConfirmRealNullVoteDialog";
import FinalConfirmVote from "./FinalConfirmVote";
// import EqualOppDialog from "./EqualOppDialog";
// import AbstentionDialog from "./AbstentionDialog";
import Utils from "../utils/Utils.js";
import InfoBox from "./InfoBox";
import { isMobile } from "mobile-device-detect";

const LOAD_DEFERRED_CONTEST = process.env.VUE_APP_deferred_contest_loading;
const OUTER_TABS_CONTAINER = "outer-tabs-container";
const INNER_TABS_CONTAINER = "inner-tabs-container";
const CONTEST_INTRO_PAGE = "contest-intro-page";
const CATEGORY_INTRO_PAGE = "category-intro-page";
const BLANK_VOTE = "blank-vote";
const NULL_VOTE = "null-vote";
const VOTE = "vote";

export default {
  mixins: [ElectionMixin],
  async mounted() {
    this.utils = new Utils();
    this.isMobile = isMobile;
    this.loadDeferredContest =
      this.loadDeferredContest == null ? false : this.loadDeferredContest;

    this.$root.$on("lock", () => {
      this.noScroll();
    });
    this.$root.$on("unlock", () => {
      this.scroll();
    });
    await this.getElection();
    this.loaded = true;
    this.orderedContests.forEach(contestGroup => {
      this.categorySelected[contestGroup.elements[0].Category] = false;
    });
  },
  // updated() {
  //   //Nasconde allo screen reader i pulsanti o i tab che non deve leggere
  //   if (this.contestLevels == 1) {
  //     let button_tabs = this.getOuterNavButtons();
  //     button_tabs.forEach(x => x.setAttribute("aria-hidden", "true"));
  //   }
  //   if (this.contestLevels > 1) {
  //     let outer_button_tabs = document
  //       .getElementById(OUTER_TABS_CONTAINER)
  //       .querySelector(".md-tabs-container")
  //       .querySelectorAll("div");

  //     for (let i = 1; i < outer_button_tabs.length; i++) {
  //       outer_button_tabs[i].setAttribute("aria-hidden", "true");
  //     }
  //     if (this.activeCategory) {
  //       let button_tabs = this.getInnerNavButtons();
  //       button_tabs.forEach(x => x.setAttribute("aria-hidden", "true"));
  //     }
  //   }
  // },
  data: function() {
    return {
      utils: null,
      election: null,
      electionType: null,
      listOrCandidates: null,
      contestList: [],
      voted: [],
      listVoted: [],
      ready: false,
      atLeastOne: false,
      tooMany: false,
      contestNames: {},
      visibleContests: {},
      selectedContests: {},
      categorySelected: {},
      activeTabForCategory: {},
      confirmVoteDialog: false,
      //confirmBlank: false,
      //confirmNull: false,
      confirmAbstention: false,
      openFinalConfirm: false,
      changed: false,
      changedSecondLevel: false,
      voteBlank: false,
      voteNull: false,
      hidediv: false,
      confirmEqual: true,
      loaded: false,
      loadDeferredContest: LOAD_DEFERRED_CONTEST,
      CONTEST_INTRO_PAGE: CONTEST_INTRO_PAGE,
      CATEGORY_INTRO_PAGE: CATEGORY_INTRO_PAGE,
      OUTER_TABS_CONTAINER: OUTER_TABS_CONTAINER,
      INNER_TABS_CONTAINER: INNER_TABS_CONTAINER,
      BLANK_VOTE: BLANK_VOTE,
      NULL_VOTE: NULL_VOTE,
      VOTE: VOTE,
      actualTab: null,
      activeTab: null,
      activeCategory: null,
      blankOrNullActive: false,
      voteSent: false,
      totCandidatesOrAffiliations: 0,
      lastFocus: "",
      lastEqOppFocus: "",
      finalConfirmCancel: false,
      lastVoteFocus: "",
      hasPreferences: false,
      readAriaLive: true,
      listWithPreference: false
    };
  },
  props: ["electionId"],

  methods: {
    selectCandidateInContest(evt) {
      //invoca il metodo del minix
      this.candidateSelected(evt);

      //controlla se nel contesto scelto è stato selezionato almeno un candidato
      let hasContestSelectedCandidates =
        this.voted.filter(item => item.contestId === evt.contestId).length > 0;

      //memorizza se nel contesto attuale è stato scelto almeno un candidato
      this.selectedContests[evt.contestId] = hasContestSelectedCandidates;
    },
    selectAffiliationInContest(evt) {
      //invoca il metodo del minix
      this.affiliationSelected(evt);

      //controlla se nel contesto scelto è stata selezionata almeno una lista
      let hasContestSelectedAffiliations =
        this.listVoted.filter(item => item.contestId === evt.contestId).length >
        0;

      //memorizza se nel contesto attuale è stata scelta almeno una lista
      this.selectedContests[evt.contestId] = hasContestSelectedAffiliations;
    },
    noScroll() {
      if (document.getElementById("preference-modal") === null) {
        document
          .getElementById("election-modal")
          .setAttribute("aria-hidden", "true");
        document
          .getElementById("election-modal")
          .querySelectorAll("input,button,a")
          .forEach(x => (x.tabIndex = "-1"));
      } else {
        document
          .getElementById("preference-modal")
          .setAttribute("aria-hidden", "true");
        document
          .getElementById("preference-modal")
          .querySelectorAll("input,button,a")
          .forEach(x => (x.tabIndex = "-1"));
      }

      this.lastFocus = document.activeElement;
      if ((this.sexVoted == 1 || this.sexVoted == -1) && this.confirmEqual) {
        this.lastEqOppFocus = document.activeElement;
      }
      this.hidediv = true;

      //blocca il focus anche del mouse
      document.getElementById("app").addEventListener(
        "focusin",
        (this.handler = function() {
          let info = document.querySelector("#info,#finalConfirmationVote");
          if (info) {
            info.querySelectorAll("input,button,a")[0].focus();
          }
        })
      );

      this.$forceUpdate();
    },
    scroll() {
      if (document.getElementById("preference-modal") === null) {
        document
          .getElementById("election-modal")
          .setAttribute("aria-hidden", "false");
        document
          .getElementById("election-modal")
          .querySelectorAll("input,button,a")
          .forEach(x => x.removeAttribute("tabindex"));
      } else {
        document
          .getElementById("preference-modal")
          .setAttribute("aria-hidden", "false");
        document
          .getElementById("preference-modal")
          .querySelectorAll("input,button,a")
          .forEach(x => x.removeAttribute("tabindex"));
      }
      this.hidediv = false;
      //focus in uscita di modale
      this.lastFocus.focus();
      if ((this.sexVoted == 1 || this.sexVoted == -1) && this.confirmEqual) {
        this.lastEqOppFocus.focus();
      }
      if (this.finalConfirmCancel) {
        this.lastVoteFocus.focus();
        this.finalConfirmCancel = false;
      }
      document
        .getElementById("app")
        .removeEventListener("focusin", this.handler);
      this.$forceUpdate();
    },
    lastClick() {
      if (this.voteBlank || this.voteNull) {
        this.lastVoteFocus = document.activeElement;
      }
    },
    lastClickVote(evt) {
      this.vote(evt);
      this.lastVoteFocus = document.activeElement;
    },
    getOuterNavButtons() {
      return document
        .getElementById(OUTER_TABS_CONTAINER)
        .querySelector("div")
        .querySelectorAll("button");
    },
    getInnerNavButtons() {
      return document
        .getElementById(INNER_TABS_CONTAINER + this.activeCategory)
        .querySelector("div")
        .querySelectorAll("button");
    },
    getActiveTabButtons() {
      return document
        .getElementById(this.activeTab)
        .querySelectorAll("a,button");
    },
    getFirstActiveTabButton() {
      return document.getElementById(this.activeTab).querySelector("a,button");
    },
    getFirstToolbarButton() {
      //reperisce i bottoni della toolbar abilitati
      let enabledToolbarButtons = document
        .querySelector(".toolbar")
        .querySelectorAll("button:enabled");

      return enabledToolbarButtons.length > 0 ? enabledToolbarButtons[0] : null;
    },
    handleTabCandidatesNavigation(event) {
      let actualElement = event.target;

      //se ci sono dei contesti
      if (this.contestLevels > 0) {
        //reperisce i bottoni di navigazione "esterni"
        let outerNavButtons = this.getOuterNavButtons();

        //reperisce il primo bottone della toolbar abilitato
        let firstToolbarButton = this.getFirstToolbarButton();

        //se è stata usata la combinazione di tasti SHIFT+TAB
        if (event.shiftKey) {
          //se ci si trova sul primo bottone della toolbar
          if (
            firstToolbarButton != null &&
            actualElement == firstToolbarButton
          ) {
            //se non è stato selezionato alcun tab di navigazione
            if (this.activeTab == null) {
              //se c'è un solo livello di bottoni di navigazione
              if (this.contestLevels == 1) {
                //dà il focus all'ultimo bottone di navigazione esterno
                outerNavButtons[outerNavButtons.length - 1].focus();
              }
              //se ci sono due livelli di bottoni di navigazione
              else {
                //se è stata scelta una categoria
                if (this.activeCategory != null) {
                  //reperisce i bottoni di navigazione "interni"
                  let innerNavButtons = this.getInnerNavButtons();

                  //dà il focus all'ultimo bottone di navigazione interno
                  innerNavButtons[innerNavButtons.length - 1].focus();
                } else {
                  //dà il focus all'ultimo bottone di navigazione esterno
                  outerNavButtons[outerNavButtons.length - 1].focus();
                }
              }
            }
            //se è stato selezionato un tab di navigazione
            else {
              //recupera tutti i bottoni all'interno del tab attivo
              let activeTabButtons = this.getActiveTabButtons();

              //dà il focus all'ultimo bottone del tab selezionato
              if (activeTabButtons[activeTabButtons.length - 1].disabled) {
                activeTabButtons[activeTabButtons.length - 2].focus();
              } else {
                activeTabButtons[activeTabButtons.length - 1].focus();
              }
            }

            //impedisce il propagarsi dell'evento SHIFT+TAB
            event.preventDefault();
          }
          //se non ci si trova sul primo bottone della toolbar ed è stato selezionato un tab
          else if (this.activeTab != null) {
            //recupera il primo bottone all'interno del tab attivo
            let firstActiveTabButton = this.getFirstActiveTabButton();

            //se ci si trova sul primo bottone del tab attivo
            if (actualElement == firstActiveTabButton) {
              //se c'è un solo livello di bottoni di navigazione
              if (this.contestLevels == 1) {
                //dà il focus all'ultimo bottone di navigazione esterno
                outerNavButtons[outerNavButtons.length - 1].focus();
              }
              //se ci sono due livelli di bottoni di navigazione
              else {
                //se è stata scelta una categoria
                if (this.activeCategory != null) {
                  //reperisce i bottoni di navigazione "interni"
                  let innerNavButtons = this.getInnerNavButtons();

                  //dà il focus all'ultimo bottone di navigazione interno
                  innerNavButtons[innerNavButtons.length - 1].focus();
                } else {
                  //dà il focus all'ultimo bottone di navigazione esterno
                  outerNavButtons[outerNavButtons.length - 1].focus();
                }
              }

              //impedisce il propagarsi dell'evento SHIFT+TAB
              event.preventDefault();
            }
          }
        }
        //se è stato usato il tasto TAB
        else {
          //se non è stato selezionato alcun tab di navigazione
          if (this.activeTab == null) {
            //se l'elemento su cui viene effettuato il tab è l'ultimo bottone di navigazione esterno
            if (actualElement == outerNavButtons[outerNavButtons.length - 1]) {
              //se c'è un solo livello di bottoni di navigazione
              if (this.contestLevels == 1) {
                //se c'è un bottone della toolbar abilitato
                if (firstToolbarButton != null) {
                  //dà il focus al primo bottone della toolbar abilitato
                  firstToolbarButton.focus();

                  //impedisce il propagarsi dell'evento TAB
                  event.preventDefault();
                }
              }
              //se ci sono due livelli di bottoni di navigazione
              else {
                //se è stata scelta una categoria
                if (this.activeCategory != null) {
                  //reperisce i bottoni di navigazione "interni"
                  let innerNavButtons = this.getInnerNavButtons();

                  //dà il focus al primo bottone di navigazione interno
                  innerNavButtons[0].focus();
                } else {
                  //dà il focus al primo bottone della toolbar abilitato
                  firstToolbarButton.focus();
                }

                //impedisce il propagarsi dell'evento TAB
                event.preventDefault();
              }
            }
            //se è stata scelta una categoria
            else if (this.activeCategory != null) {
              //reperisce i bottoni di navigazione "interni"
              let innerNavButtons = this.getInnerNavButtons();

              //se ci si trova sull'ultimo bottone di navigazione interno
              if (
                actualElement == innerNavButtons[innerNavButtons.length - 1]
              ) {
                //dà il focus al primo bottone della toolbar abilitato
                firstToolbarButton.focus();

                //impedisce il propagarsi dell'evento TAB
                event.preventDefault();
              }
            }
          }
          //se è stato selezionato un tab di navigazione
          else {
            //recupera tutti i bottoni all'interno del tab attivo
            let activeTabButtons = this.getActiveTabButtons();

            //se l'elemento su cui viene effettuato il tab è l'ultimo bottone di navigazione esterno
            if (actualElement == outerNavButtons[outerNavButtons.length - 1]) {
              //se c'è un solo livello di bottoni di navigazione
              if (this.contestLevels == 1) {
                //dà il focus al primo bottone del tab attivo
                activeTabButtons[0].focus();
              }
              //se ci sono due livelli di bottoni di navigazione
              else {
                //reperisce i bottoni di navigazione "interni"
                let innerNavButtons = this.getInnerNavButtons();

                //dà il focus al primo bottone di navigazione interno
                innerNavButtons[1].focus();
              }

              //impedisce il propagarsi dell'evento TAB
              event.preventDefault();
            }
            //se l'elemento su cui viene effettuato il tab è l'ultimo bottone del tab attivo
            //oppure è il penultimo e l'ultimo è disabilitato
            else if (
              actualElement == activeTabButtons[activeTabButtons.length - 1] ||
              (actualElement == activeTabButtons[activeTabButtons.length - 2] &&
                activeTabButtons[activeTabButtons.length - 1].disabled)
            ) {
              //se c'è un bottone della toolbar abilitato
              if (firstToolbarButton != null) {
                //dà il focus al primo bottone della toolbar abilitato
                firstToolbarButton.focus();
              }

              //impedisce comunque il propagarsi dell'evento TAB
              event.preventDefault();
            }
            //se è stata scelta una categoria
            else if (this.activeCategory != null) {
              //reperisce i bottoni di navigazione "interni"
              let innerNavButtons = this.getInnerNavButtons();

              //se ci si trova sull'ultimo bottone di navigazione interno
              if (
                actualElement == innerNavButtons[innerNavButtons.length - 1]
              ) {
                //dà il focus al primo bottone del tab attivo
                activeTabButtons[0].focus();

                //impedisce il propagarsi dell'evento TAB
                event.preventDefault();
              }
            }
          }
        }
      }
    },
    handleContestTabNavigation(e) {
      let focusable = document
        .querySelector("#election-modal")
        .querySelectorAll("a,button:enabled");

      if (focusable.length) {
        let last = focusable[focusable.length - 1];
        let shift = e.shiftKey;
        if (shift) {
          this.handleTabCandidatesNavigation(e);
        } else {
          if (e.target === last) {
            e.preventDefault();
          } else {
            this.handleTabCandidatesNavigation(e);
          }
        }
      }
    },
    changeTab(evt, isCategoryTab) {
      if (
        evt != undefined &&
        evt !== CONTEST_INTRO_PAGE &&
        !evt.startsWith(CATEGORY_INTRO_PAGE)
      ) {
        this.actualTab = evt;
        this.$emit("actualTab", "#" + this.actualTab);
        if (isCategoryTab) this.changed = true;
        else this.changedSecondLevel = true;

        let found;

        if (isCategoryTab) {
          if (this.contestLevels === 1) {
            this.activeTab = evt;
          } else if (this.contestLevels === 2) {
            this.activeCategory = evt;
          }
        } else if (this.contestLevels === 2) {
          this.activeTab = evt;
        }

        this.orderedContests.forEach(el => {
          if (el.name == this.actualTab) found = true;

          //se è stata scelta una categoria
          if (isCategoryTab) {
            let category = el.elements[0].Category;

            //renderizza solo i contesti della categoria scelta
            this.categorySelected[category] = category == this.actualTab;
          }
        });
        if (!found && !this.contestNames[this.actualTab]) {
          this.loaded = false;
        }
        this.contestNames[this.actualTab] = true;

        //se non si tratta di un tab di categoria si tratta sicuramente di due livelli, perché se non ci fossero livelli non potrebbe
        //essere chiamato questo metodo, se il livello fosse uno, si dovrebbe necessariamente trattare di un tab di categoria
        //quindi la condizione è:
        //-non si tratta di un tab di categoria (due livelli)
        //-un livello
        if (!isCategoryTab || this.contestLevels === 1) {
          //memorizza il tab attuale del contesto per la categoria
          this.activeTabForCategory[this.activeCategory] = this.activeTab;

          let visibleContestKeys = Object.keys(this.visibleContests);
          //per tutti i contesti viene deciso se sono visibili o meno
          visibleContestKeys.forEach(visibleContestKey => {
            //il contesto è visibile se:
            //-si tratta del contesto di cui è stato selezionato il tab (serve per il caso in cui ci si trova su un livello)
            //-si tratta di un contesto in cui è stato scelto un candidato da votare (in modo che non si perdano le precedenti selezioni dei candidati)
            //-si tratta di un contesto precedentemente selezionato per una categoria (serve perché quando ci si sposta fra categorie,
            // tornando su una categoria precedentemente selezionata si vuole che appaia anche il contesto precedentemente selezionato)
            this.visibleContests[visibleContestKey] =
              visibleContestKey == this.actualTab ||
              this.selectedContests[visibleContestKey] ||
              (this.contestLevels === 2 &&
                Object.keys(this.activeTabForCategory).some(category => {
                  return (
                    this.activeTabForCategory[category] === visibleContestKey
                  );
                }));
          });
        }
        //nasconde i tab non selezionati
        let tabs;
        if (isCategoryTab) {
          tabs = document
            .getElementById("outer-tabs-container")
            .querySelectorAll(".md-tab");
        } else {
          tabs = document
            .getElementById(INNER_TABS_CONTAINER + this.activeCategory)
            .querySelectorAll(".md-tab");
        }

        tabs.forEach(x => x.setAttribute("aria-hidden", "true"));
        document
          .getElementById(this.actualTab)
          .setAttribute("aria-hidden", "false");
        //document.getElementById(this.actualTab).focus();

        this.$forceUpdate();
      }
    },
    async getElection() {
      let election = await this.$store.state.ceoCbbService.getElection(
        this.$store.state.voterIdentification.EventIdentifier.Id,
        this.electionId,
        this.$store.state.voterIdentification.Voter.VoterIdentifier.VoterId[0]
      );

      if (election.error) {
        //(election.error);
        alert(election.error + "\n\n" + this.$store.state.alertMessage);
        return;
      }
      this.election = election;
      this.electionType = election.Election[0].ElectionType;
      this.listOrCandidates = // CANDIDATES / AFFILIATIONS
        election.Election[0].ElectionVotingContest.ChoiceType;

      this.$emit("electionRetrieved");
      this.contestList = this.election.Election[0].ElectionVotingContest.ChoicesContestIdentifier;
      this.election.Election[0].ElectionVotingContest.ChoicesContestIdentifier.forEach(
        el => {
          this.contestNames[el.Id] = false;
          this.visibleContests[el.Id] = false;
          this.selectedContests[el.Id] = false;
        }
      );
    },
    totalCandidatesOrAffiliations(value) {
      this.totCandidatesOrAffiliations =
        value + this.totCandidatesOrAffiliations;
    }
  },
  computed: {
    unorderedContests: function() {
      return this.utils.unorderedContests(this.contestList); // torna i contest con catgory: null
    },
    orderedContests: function() {
      return this.utils.orderedContests(this.contestList); //torna i contest ordinati per category
    },
    contestLevels: function() {
      // calcola quanti livelli di tab devono essere visualizzati [0..2]
      this.$emit(
        "moreLevels",
        this.orderedContests.length > 1 || this.unorderedContests.length > 1
      );
      return this.orderedContests.length > 1
        ? 2
        : this.unorderedContests.length > 1
        ? 1
        : 0;
    }
  },

  components: {
    Contest,
    NoAllPreferenceDialog,
    //ConfirmNullVoteDialog,
    FinalConfirmVote,
    InfoBox
    // AbstentionDialog,
    //ConfirmRealNullVoteDialog,
    // EqualOppDialog
  }
};
</script>
<style scoped>
.title-alert {
  font-weight: bold;
  font-size: 24px;
  padding: 22px;
  background: #fff3cd;
  border-radius: var(--br);
  background-color: var(--pcolor);
  margin: 30px 30px 10px 30px;
  color: #fff;
  flex: 1 1 100%;
  text-align: center;
  font-size: 16px;
}

.dialog {
  height: 100%;
  width: 100%;
  max-height: 100%;
  max-width: 100%;
  /* background-color: red; */
}
.toolbar {
  position: sticky !important;
  bottom: 0px !important;
  width: 100% !important;
}

.md-button {
  border-radius: var(--brb);
}

.toolbar .md-card {
  border: none !important;
}

/* .toolbar {
  position: sticky;
  bottom: 0px;
} */
.md-dialog2 {
  width: 50%;
  height: 50%;
  max-width: 50%;
  max-height: 50%;
  overflow: auto;
}
.mg {
  margin: 10px;
  padding: 2px;
}
.centered {
  align-content: center;
}
.dis {
  pointer-events: none;
}

.md-tabs-navigation {
  background: #448aff !important;
  color: #fff !important;
}

.md-card {
  box-shadow: none !important;
  border: 1px solid #dedede !important;
}

.md-card .md-title {
  font-size: 24px;
  letter-spacing: 0;
  line-height: 32px;
  background: #fff !important;
}

.btn-align {
  text-align: center !important;
  padding-left: 20px;
}

.md-tabs.md-theme-default .md-tabs-navigation .md-button.md-active,
.md-tabs.md-theme-default .md-tabs-navigation .md-button.md-active .md-icon {
  color: var(--pcolor) !important;
  background-color: transparent !important;
}

.md-tabs-content {
  height: 100vh !important;
  max-height: 60% !important;
}

.md-layout.content-election-w {
  width: 80%;
  margin: 0 auto !important;
  padding: 20px 0 50px 0;
}

.space2[data-v-6abee2b4] {
  margin: 5px !important;
  padding: 10px 10px 10px 90px !important;
}

.content-light-w {
  background: #f5f5f5;
  padding-top: 30px;
  margin-left: 0;
  padding-left: 16px;
  margin-right: 0;
  padding-right: 22px;
  padding-bottom: 30px;
}
.content-light-w .md-button.md-active {
  color: #fff !important;
  background: var(--pcolor) !important;
}

.content-light-w .md-button.md-theme-default.md-primary,
.content-light-w .md-button.md-theme-default.md-primary .md-icon-font {
  color: var(--pcolor) !important;
  color: var(
    --md-theme-default-primary-on-background,
    var(--pcolor)
  ) !important;
}

.md-button.md-theme-default.md-raised:not([disabled]).md-primary {
  background-color: var(--pcolor) !important;
  color: #fff !important;
  box-shadow: none;
}

.md-button.md-theme-default.md-raised:not([disabled]).md-accent {
  background-color: #fff !important;
  border: 1px solid var(--pcolor);
  color: var(--pcolor);
  box-shadow: none;
}

.md-icon-font {
  color: var(--pcolor) !important;
}

.md-theme-default :not(input):not(textarea)::selection {
  background-color: #ff5252;
  background-color: var(--md-theme-default-accent-on-background, #ff5252);
  color: #fff;
  color: var(--md-theme-default-text-primary-on-accent, #fff);
}

.md-button.md-theme-default.md-primary .md-icon-font {
  color: #448aff;
  color: var(--md-theme-default-primary-on-background, var(--pcolor));
}
.md-icon.md-theme-default.md-icon-font {
  color: rgba(0, 0, 0, 0.8);
  color: var(--md-theme-default-icon-on-background, rgba(0, 0, 0, 0.8));
}
.content-light-w .md-icon {
  color: var(--pcolor) !important;
}
.md-button.md-theme-default.md-raised:not([disabled]).md-primary[data-v-40e8ffc9] {
  background-color: var(--pcolor) !important;
}

.md-button.md-theme-default.md-raised:not([disabled]).md-primary[data-v-40e8ffc9][data-v-40e8ffc9] {
  background-color: var(--pcolor) !important;
  color: #fff !important;
}

.md-button.md-theme-default.md-raised[disabled] {
  color: #3d3d3d;
}

.md-button.md-tab-nav-button.md-theme-default.md-ripple {
  font-weight: 700 !important;
  border-radius: 5px;
}

.md-tabs-indicator {
  background-color: var(--pcolor) !important;
  background-color: var(
    --md-theme-default-primary-on-background,
    var(--pcolor)
  );
}

.md-button.md-active {
  color: var(--pcolor) !important;
  color: var(--md-theme-default-primary-on-background, var(--pcolor));
}

/* .md-tab {
  max-width: 800px !important;
} */

/*  color: var(--pcolor) !important; */
button .md-active {
  color: var(--pcolor) !important;
}

.md-tab {
  width: 100%;
  max-width: 100% !important;
  flex: 1 0 100%;
  padding: 16px;
}

.md-subtitle {
  margin-bottom: 10px !important;
}

.md-dialog-container {
  width: 100% !important;
  max-width: 100% !important;
}

.md-dialog-container {
  display: block;
  flex-flow: column;
  flex: 1;
  height: 110vh !important;
}

.content-election-w {
  display: contents !important;
  width: 80%;
  margin: 0 auto !important;
  padding: 20px 0 50px 0;
  max-width: 80%;
  left: 0 !important;
  position: static !important;
}

/* .md-dialog {
  width: 90% !important;
  height: 90% !important;
  max-width: 90% !important;
  max-height: 90% !important;
} */

md-tabs {
  width: 100% !important;
  max-width: 100% !important;
  display: inline-block !important;
}

.light-w {
  width: 100% !important;
  display: grid !important;
}

.btn-align[data-v-40e8ffc9] {
  text-align: center !important;
  padding-left: 0px;
}

.fixtab {
  padding: 16px;
}

.preferenze-label {
  font-weight: bold;
  font-size: 14px;
  color: var(--pcolor) !important;
  padding-top: 8px;
}

.full-screen-dialog {
  max-width: 100%;
  max-height: 100%;
  width: 100%;
  height: 100%;
  border-radius: 0;
}

.full-screen-dialog .md-dialog-container {
  max-width: 100% !important;
  height: 100% !important;
}

.action-button {
  text-align: center;
  margin: 10px 0px 10px 0px;
}

.md-ripple.md-button-content {
  font-weight: 700 !important;
}

@media screen and (max-width: 800px) {
  .action-button {
    max-width: 300px;
  }
}
</style>
